import { SearchInput } from 'V2Components'
import { AdvancedSearch } from 'V2Components'
import { useResourcesViewContext } from 'features/resources'
import { SelectDropDown, ToggleCloudControl, Button } from 'procyon-ui'
import React, { useState } from 'react'
import { AddGitServerModal } from './AddGitServerModal'

const ResourceFilterHeader = ({
  cloudOptions,
  dropDownItems,
  disableAccountControls,
  activeCloudType,
  setActiveCloudType,
  selectedDropdownValue,
  setSelectedDropdownValue,
  HeaderFilter = null,
  searchKey,
  setSearchKey,
  suggestions = [],
  defaultSuggestions = [],
  filterSaveKey,
  AdvancedSearchComponent = null,
  hidePrivateCloud = true
}) => {
  const { filterOptions } = useResourcesViewContext()
  const [showAddGitServerModal, setShowAddGitServerModal] = useState(false)

  const options = hidePrivateCloud ? cloudOptions.filter((ct) => ct !== 'PRIVATE') : cloudOptions

  return (
    <>
      <div className='flex justify-between items-center'>
        {!filterOptions.hideCloudOptions && (
          <div className='flex gap-4'>
            {!filterOptions.hideCloudToggle && (
              <ToggleCloudControl
                options={options}
                disabled={disableAccountControls}
                value={activeCloudType}
                ariaLabel='cloud-select'
                onChange={(_, values) => {
                  if (values) {
                    setActiveCloudType(values)
                    setSelectedDropdownValue('')
                  }
                }}
                multiSelect={false}
              />
            )}

            {!filterOptions.hideDropdown && activeCloudType !== 'PRIVATE' && (
              <SelectDropDown
                sx={{ minWidth: '300px' }}
                showHelpText={false}
                // @ts-ignore
                onChange={(e) => setSelectedDropdownValue(e.target.value)}
                disabled={disableAccountControls}
                menuItems={[
                  {
                    label: 'All',
                    selected: false,
                    value: '',
                    disabled: false
                  },
                  ...dropDownItems
                ]}
                value={selectedDropdownValue}
              />
            )}
            {HeaderFilter}
          </div>
        )}
        <div className='flex gap-2 items-center'>
          {AdvancedSearchComponent && AdvancedSearchComponent}
          <AdvancedSearch
            filterSaveKey={filterSaveKey}
            defaultSuggestions={defaultSuggestions}
            suggestions={suggestions}
            searchKey={searchKey}
            setSearchKey={setSearchKey}
          />
        </div>
      </div>
    </>
  )
}

export { ResourceFilterHeader }
